module.exports = __webpack_public_path__ + "static/img/ENessential4.484b6888.png";